module.exports = __webpack_public_path__ + "src/assets/img/error-icon.3576741c.png";